<template>
  <div class="color-change">
    <div>
      <label class="color-change__picker-label" :class="{'disabled-cursor': disabled}" :for="inputId">
        <div
          class="color-change__picker-label-inner"
          :style="{ background: value }"
        ></div>
      </label>
        <input
          :value="value"
          :id="inputId"
          placeholder=""
          :disabled="disabled"
          type="color"
          class="color-change__picker-input"
          @input="onColorSelect($event.target.value)"
        />
    </div>

    <input
      :value="value"
      type="text"
      class="color-change__text-input"
      @input="onColorSelect($event.target.value)"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String
    },
    def: {
      type: String,
      default: "#000000"
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    inputId: "color-change-id"
  }),

  mounted() {
    this.makeSetup();
  },

  methods: {
    makeSetup() {
      if (!this.value) {
        this.$emit("input", this.def);
      }

      this.inputId = Math.random()
          .toString(36)
          .replace(/[^a-z]+/g, "")
          .substr(0, 5);

      this.$forceUpdate();
    },

    onColorSelect(value) {
      this.$emit("input", value);
    }
  }
}
</script>

<style lang="scss">
$borderColor: #ddd;

.color-change {
  display: grid;
  grid-template-columns: 36px 1fr;

  .disabled-cursor {
    cursor: not-allowed;
  }

  &__picker-input {
    height: 0px;
    width: 0px;
    display: block;
    opacity: 0;
    position: relative;
    top: -5px;
    z-index: -1;
  }

  &__picker-label {
    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
    justify-items: center;
    height: 38px;
    width: 38px;
    border: 1px solid $borderColor;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-right: none;
    cursor: pointer;
    box-sizing: border-box;

    &-inner {
      height: 16px;
      width: 16px;
      border-radius: 50%;
    }
  }

  &__text-input {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;

    &:focus {
      border-color: $borderColor !important;
    }
  }
}
</style>
